export const emailRegEx = RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);